"use strict";

import React from "react";
import TimezoneSearch from "../Timezone-Search";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
var validator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const mNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const defaultTimeZone = moment.tz.guess();

class SuggestedDateTime extends React.Component {
    constructor(p) {
      super(p);
      this.state = {
        canSubmit: false,
        showDateError: false,
        dateKey: new Date().getTime(),
        selectedSuggestedDate: null,
        selectedSuggestedTime: null,
        fShowOtherDateTimerPicker: false,
        timezone: null,
        date: null,
        showDate: '         ',
        showTime: '         ',
        showTimezonePicker: false,
        mentorEmail: '',
        hideMentorEmailDiv: true,
        mentorEmailErrorMsg: '',
        startDate: moment(p.scheduledFor),
        };
    }

    componentWillMount() {
      const { mentorEmail, mentorTimezone } = this.props;
      
      console.log('mentorTimezone', mentorTimezone);

      const timezoneName = mentorTimezone ? mentorTimezone: defaultTimeZone;

      // const abbr = moment.tz(timezoneName).format('z');
      // const offset = moment.tz(timezoneName).format('Z');
      // const label = (timezoneName + ' | ' + abbr + ' | ' + 'GMT' + offset)
      // const timezone =  { name: timezoneName, abbr: abbr, offset: offset, label: label };

      this.setState({ mentorEmail, timezone: timezoneName});
      
      this._selectFirstDateAndTime();
      this._showSavedDateAndTimeOnSuggestAnotherTime();
    }

    _selectFirstDateAndTime = () => {
        let { suggestedConfTimes, scheduledFor } = this.props;

        // Select By-Default
        let suggestedDates = suggestedConfTimes && suggestedConfTimes.dates;
        let suggestedTimes = suggestedConfTimes && suggestedConfTimes.timeSlots;

        this.setState({
            selectedSuggestedDate: suggestedDates[0],
            selectedSuggestedTime: suggestedTimes[0],
        });
    }

    _showSavedDateAndTimeOnSuggestAnotherTime = () => {
        const { scheduledFor } = this.props;
        if(scheduledFor) {
            const showDate = moment(scheduledFor).format("ddd, MMM D");
            const showTime = moment(scheduledFor).format("h:mm A");
            this.setState({ showDate, showTime })
        }
    }

  render() {

    const { 
      selectedSuggestedDate, selectedSuggestedTime, scheduled, timezone, showDateError, fShowOtherDateTimerPicker,
      showDate, showTime, mentorEmail, hideMentorEmailDiv, mentorEmailErrorMsg, showScheduledDate, showScheduledTime
    } = this.state;
    
    const { scheduledFor } = this.props;

    const SubmitDisabled = mentorEmailErrorMsg.length || !mentorEmail.length || !timezone || showDateError ||
    !(scheduled || (selectedSuggestedDate && selectedSuggestedTime));
    
    return (
            <div className="row">
              <div className="col-xs-12 timefix mb20">
                <div className="f16">
                    I can discuss my experience on
                    <span className="border-bottom ml5 mr5">
                      {fShowOtherDateTimerPicker
                        ? showDate
                        : selectedSuggestedDate
                          ? this._formatDate()
                          : showScheduledDate
                            ? showScheduledDate
                            : <span>&nbsp;</span>
                      }
                    </span> at
                    <span className="border-bottom ml5 mr5">
                      {fShowOtherDateTimerPicker
                        ? showTime
                        : selectedSuggestedTime
                          ? this._formatTime(selectedSuggestedTime)
                          : showScheduledTime
                            ? showScheduledTime
                            :  <span>&nbsp;</span>
                      }
                    </span>,
                    <span className="border-bottom ml5 mr5" style={{ cursor: 'pointer' }} >{moment.tz(scheduledFor ,timezone).format('z')} </span>
                    {this._showTimezoneSearchBox()}
                </div>
              </div>
              {this._makeTable()}
              {this._showCustomDateTimePanel()}
              <div className="col-xs-12 mb10">
                <label className="customCheckbox font-weight-normal pull-left">Suggest other time
                    <input
                      type="checkbox"
                      checked={fShowOtherDateTimerPicker}
                      onClick={() => {
                        this.setState({
                            fShowOtherDateTimerPicker: !fShowOtherDateTimerPicker,
                            showDateError: false,
                            scheduled: null,
                            selectedSuggestedDate: null,
                            selectedSuggestedTime: null,
                        }, () => {
                          if(!fShowOtherDateTimerPicker) {this._selectFirstDateAndTime()}
                        })
                      }}
                    />
                    <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-xs-12 col-md-6 mb10" hidden={hideMentorEmailDiv}>
                <label>Suggested email: </label>
                <input
                    type="text"
                    placeholder="Enter your email"
                    className="form-control"
                    onChange={this._handleEmailChange}
                    value={mentorEmail}
                />
                <span style={{ color: 'red' }}>{mentorEmailErrorMsg}</span>
              </div>
              <div className="col-xs-12">
                <button type="button" className="btn btn-primary"
                        disabled = {SubmitDisabled}
                        onClick = {this._submitEmail}
                >Submit</button>
                {
                  this.props.closeModal
                    ? <button type="button" className="btn btn-default ml10"
                              onClick={() => this.props.closeModal()}
                      >Cancel</button>
                  : null
                }
              </div>
            </div>
    );
  }

  _submitEmail = () => {
      const { hideMentorEmailDiv } =this.state;
      if(hideMentorEmailDiv) {
        this.setState({ hideMentorEmailDiv: false });
      }
      else {
        this._handleSubmit();
        if(this.props.closeModal) this.props.closeModal();
    }
  }

    _showTimezoneSearchBox = () => {
        const { timezone, showTimezonePicker } = this.state;
        if (showTimezonePicker) {
            return (
                <TimezoneSearch
                    defaultText="Search Timezone..."
                    dtz={timezone}
                    _handleSelection={newTimezone => {
                      if (newTimezone && newTimezone !== timezone ) {
                        this.setState({ timezone: newTimezone, showTimezonePicker: !showTimezonePicker })
                      }
                    }}
                />
            )
        }
        else {
          return (
            <span>
              <br />
              <span 
                style={{ color: '#337ab7', cursor: 'pointer', fontSize: 14 }}
                onClick={() => this.setState({ showTimezonePicker: true })}
              >
                Change timezone
              </span>
            </span>
          )
        }
    }

  _showCustomDateTimePanel = () => {
    let { fShowOtherDateTimerPicker, showDateError, inline, startDate } = this.state;
    if (!fShowOtherDateTimerPicker) return null;
    const diff = startDate.diff(moment(), "days");

    return (
        <div className="col-xs-12 col-md-6 mb20">
            <label className="pull-left mr10">Date</label>
            <DatePicker className="form-control w-auto"
                onChange={d => {
                    this._checkDate(d.valueOf());
                    this.setState({ startDate: d, inline: false });
                }}
                selected={diff < 180 ? startDate : moment()}
                minDate={moment()}
                todayButton={"Today"}
                showMonthDropdown
                showTimeSelect
                timeFormat="h:mm A"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MM/DD/YY h:mm A"
                autoFocus={true}
            />
            {showDateError ? (
                <div style={{ color: "red" }}>Invalid date</div>
            ) : null}
        </div>
    );
  };

  _makeTable = () => {
    const { suggestedConfTimes } = this.props;
    const { fShowOtherDateTimerPicker, selectedSuggestedDate, selectedSuggestedTime } = this.state;
    const suggestedDates = suggestedConfTimes && suggestedConfTimes.dates;
    const suggestedTimes = suggestedConfTimes && suggestedConfTimes.timeSlots;

    if (fShowOtherDateTimerPicker) return null;

    if (!suggestedDates || !suggestedTimes || suggestedDates.length == 0 || suggestedTimes.length == 0 )
      return null;

    return (
        <div>
            <div className="col-xs-12">
                    <span className="pull-left mr10">Date options: </span>
                    <div className="pull-left">
                    {
                        suggestedDates && suggestedDates.map(date => {
                            return (
                                <label className="customRadio pull-left font-weight-normal mr20"
                                       key={date}>
                                  {date}
                                    <input
                                        type="radio"
                                        value={date}
                                        checked={selectedSuggestedDate == date}
                                        onClick={() => this._handleInputChange("selectedSuggestedDate", date)}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                            )
                        })
                    }
                    </div>
            </div>
            <div className="col-xs-12">
                    <span className="pull-left mr10">Time options: </span>
                    <div className="pull-left">
                        {
                            suggestedTimes && suggestedTimes.map(time => {

                                return (
                                    <label className="customRadio pull-left font-weight-normal mr20"
                                           key={time}>
                                      {this._formatTime(time)}
                                        <input
                                            type="radio"
                                            value={time}
                                            checked={selectedSuggestedTime == time}
                                            onClick={() => this._handleInputChange("selectedSuggestedTime", time)}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                )
                            })
                        }
                    </div>
            </div>
        </div>
    );
  };

  _formatTime = time => {
    let hour = Math.floor(time);
    let mints = time - hour;
    mints = mints > 0 ? ":"+ Math.floor(mints * 60) : "";

    if(hour < 12) {
      return `${hour}${mints} AM`;
    } else {
      hour = hour > 12 ? hour - 12 : hour;
      return `${hour}${mints} PM`;
    }
  };

  _checkDate = date => {
    const { scheduledFor } = this.props;
    // console.log("date", date);
    let dateInstance = moment.unix(date / 1000)._d;
    let showDate = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
    let showTime = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';

    const fValid = dateInstance instanceof Date && !isNaN(dateInstance);
    if (fValid) {
      dateInstance = moment.unix(date / 1000);
      showDate = moment(dateInstance).format("ddd, MMM D");
      showTime = moment(dateInstance).format("h:mm A");
      dateInstance = moment(dateInstance).format("YYYY-MM-DD HH:mm");

      this.setState({
        date: dateInstance,
        scheduled: date,
        showDateError: false,
        selectedSuggestedDate: null,
        selectedSuggestedTime: null,
        showDate,
        showTime
      });
    }
    else if(scheduledFor) {
        showDate = moment(scheduledFor).format("ddd, MMM D");
        showTime = moment(scheduledFor).format("h:mm A");
        this.setState({ showDate, showTime })
    }
    else {
      this.setState({ showDateError: true });
    }
  };

  _formatDate = () => {
    const { timezone, selectedSuggestedDate} = this.state;

    if(!selectedSuggestedDate) return <span>&nbsp;</span>;

    const currentMonth = parseInt(moment().tz(timezone).format("M")) - 1;
    let selectedYear = parseInt(moment().tz(timezone).format("YYYY"));

    const dayMonth = selectedSuggestedDate.split(" ");
    const selectedMonth = mNames.indexOf(dayMonth[0]);
    if(selectedMonth < currentMonth)  selectedYear++;
    const dtTime = selectedSuggestedDate.trim() + " " + selectedYear;
    console.log({dtTime});
    return moment.tz(dtTime, "MMM D YYYY", timezone).format("ddd, MMM D");

    // console.log("selectedSuggestedDate==========",selectedSuggestedDate);
    // const tz = timezone.name;
    //   const currentMonth = moment.tz(new Date(), tz).format("MM");
    //   const dayMonth = selectedSuggestedDate.split(" ");
    //   const selectedMonth = mNames.indexOf(dayMonth[0]);
    //   let addMonth = 0;
    //
    //   if (selectedMonth + 1 < currentMonth)
    //     addMonth = 12 - currentMonth + selectedMonth + 1;
    //   else
    //     addMonth = selectedMonth + 1 - currentMonth;
    //
    //   const scheduledFor = moment
    //     .tz(new Date(), tz)
    //     .add(addMonth, "months")
    //     .date(Number(dayMonth[1]))
    //     .hours(0)
    //     .minutes(0)
    //     .seconds(0)
    //     .format("ddd, MMM D");

      // return scheduledFor
  }

  _handleSubmit = () => {
    const { timezone, date : otherDtTime, selectedSuggestedTime, selectedSuggestedDate, mentorEmail } = this.state;
    let scheduledFor = null;

    if (otherDtTime) {
      scheduledFor = moment.tz(otherDtTime, timezone).tz("Zulu").format();
    } else {
      const currentMonth = parseInt(moment().tz(timezone).format("M")) -1;
      let selectedYear = parseInt(moment().tz(timezone).format("YYYY"));

      const dayMonth = selectedSuggestedDate.split(" ");
      const selectedMonth = mNames.indexOf(dayMonth[0]);
      if(selectedMonth < currentMonth)  selectedYear++;

      const hours = parseInt(selectedSuggestedTime);
      const minutes = (Number(selectedSuggestedTime) - hours) * 60;
      const dtTime = selectedSuggestedDate.trim() + " " + selectedYear + " " + hours + " " + minutes;

      scheduledFor = moment.tz(dtTime, "MMM D YYYY H m", timezone).tz("Zulu").format();
    }

    const payload = { datetime: scheduledFor, timezone };

    this.props._updateMentorEmail(mentorEmail, error => {
        if(error) {
          this.setState({mentorEmailErrorMsg : error.message, hideMentorEmailDiv : false});
        }
        else {
          this.props._saveScheduledForLaterResponse(payload);
          this.setState({mentorEmailErrorMsg : '', hideMentorEmailDiv : true});
        }
    });
  };

  _handleInputChange = (inputType, value) => {

    const { date } = this.state;
    const dateKey = new Date().getTime();
    const newState = { [inputType]: value, showDateError: null };

    if (date) {
      newState.date = null;
      newState.scheduled = null;
      newState.dateKey = dateKey;
    }

    this.setState(newState);
  };
  
  _handleEmailChange = e => {
    let mentorEmailErrorMsg = '';

    if(!validator.test(e.target.value)) mentorEmailErrorMsg = 'Email not valid';
    
    this.setState({mentorEmailErrorMsg, mentorEmail : e.target.value});
  }

}

export default SuggestedDateTime;
